import { ReactNode } from "react";
import Grid from "@mui/material/Grid2";
import { DialogContent, DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "@common/components/Typography";
import Button from "@common/components/Button";
import Dialog from "@common/components/Dialog";
import DialogTitle from "@common/components/Dialog/DialogTitle";
import DialogActions from "@common/components/Dialog/DialogActions";

export interface ConfirmDialogProps {
  actionLabel: string;
  confirmPrompt: string;
  onConfirm: () => void;
  reasonField?: ReactNode;
  actionLoading?: boolean
}
const ConfirmDialog = (
  props: ConfirmDialogProps & Pick<DialogProps, "open" | "onClose">
) => {
  const {
    open = false,
    onClose = () => {},
    onConfirm,
    actionLabel,
    confirmPrompt,
    reasonField,
    actionLoading
  } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} data-testid="confirm-dialog">
      <DialogTitle>{t(actionLabel)}</DialogTitle>
      <DialogContent>
        <Typography data-testid="confirm-dialog-content">
          {confirmPrompt}
        </Typography>
        {reasonField}
      </DialogContent>
      <DialogActions>
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{
            justifyContent: "end",
            "& > *": { mx: 1 },
          }}
        >
          <Button
            variant="outlined"
            color="greyed"
            onClick={() => onClose({}, "backdropClick")}
            data-testid="cancel-button"
          >
            {t("Cancel")}
          </Button>
          <Button
            color="error"
            onClick={onConfirm}
            loading={actionLoading}
            data-testid="confirm-button"
          >
            {t(actionLabel)}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
